import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import * as $ from 'jquery';
import { constants } from '../constants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChangeNumberService } from "./change-number.service";
declare var $: any;

@Component({
  selector: 'app-change-number',
  templateUrl: './change-number.component.html',
  styleUrls: ['./change-number.component.scss']
})
export class ChangeNumberComponent implements OnInit {
  imei = constants.IMEI_TITLE;
  phoneBrand: any;
  phoneImei: any;
  selectedLine = false;

  isFileLoadDocCopy = false;
  isFileLoadPortForm = false;
  isFileLoadDocCopyFront = false;
  isFileLoadDocCopyReverse = false;
  changeNumberForm: FormGroup;

  //ventana modal
  isShowModal = false;
  isChangeNumberBtn=false; 
  modalTitle: any;
  modalContent: any;
  isModalReload = false;

  //dato quemado que viene de WS
  lineaSolicitada = "";
  listLines = [];
  listLineData: any;

  //data objects
  fileLoadPortFormData = null;
  fileLoadDocCopyData = null;
  fileLoadDocCopyFrontData = null;
  fileLoadDocCopyReverseData = null;

  isBtnDisabled = false;
  isLoadingLines = false;
  isLoadingImei = false;

  //file input
  ACCEPT_FILES = constants.ACCEPT_FILES;
  
  constructor(public LANG: CommonUtilitiesService, private formbuilder: FormBuilder, private _router: Router, private changeNumberService: ChangeNumberService) { }

  ngOnInit() {
    
    //validaciones de formulario
    this.changeNumberForm = this.formbuilder.group({
      checkAuto: ['', [Validators.required]],
      checkTerms: ['', [Validators.required]],
      inputFileDocCopy: ['', []],
      inputFileDocCopyFront: ['', []],
      inputFileDocCopyReverse: ['', []],
      inputLines: ['', [Validators.required]],
    });

    //obtiene las lineas de sesion
    let userData = JSON.parse(localStorage.getItem("userData"));
    for (var k in userData.associatedCellPhones) {
      this.listLines.push({ "id": userData.associatedCellPhones[k].id, "linea": userData.associatedCellPhones[k].id });
    }
  }

  /**
   * Description: Método que valida si se ha subido un archivo y lo marca como OK
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  setFileOkFlag($event) {
    let id = $event.target.id;
    let filename = $('#' + id).val();

    /**
     * @AddBy Julian Ciro
     * Se añade validación que verifica la extensión del archivo
     */
    const isFileValid = constants.EXTENSION_FILE_AVAILABLE.includes(filename.substring(filename.lastIndexOf('.')).toUpperCase());
    if(!isFileValid){
      this.modalTitle = this.LANG.getLangText('EXTENSION_FILE_INVALID_TITTLE');
      this.modalContent = this.LANG.getLangText('EXTENSION_FILE_INVALID');
      this.isShowModal = true;
      $('#' + id).val(''); //ID del input file hiddden
      $('#' + id + 'Face').val(''); //ID del input que muestra la ruta del archivo seleccionado
      return;
    }

    $('#' + id + "Face").val(filename);
    //carga el archivo en base64
    this.getBase64($event.target, id);

    if (id == 'inputFilePortForm') {
      this.isFileLoadPortForm = true;
    }
    if (id == 'inputFileDocCopy') {
      this.isFileLoadDocCopy = true;
    }
    if (id == 'inputFileDocCopyFront') {
      this.isFileLoadDocCopyFront = true;
    }
    if (id == 'inputFileDocCopyReverse') {
      this.isFileLoadDocCopyReverse = true;
    }
  }
  /**
   * Description: Método que abre la ventana de carga de archivos adjuntos
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  loadHiddenFile(id: string) {
    $("#" + id).click();
  }
  /**
   * Description: Método que valida que existan los archivos adjuntos
   * Autor: Steven Sterling 
   * @param N/A
   * @return N/A
   */
  validateAttachedFiles() {
    var isValidFileLoad = false;
    var fileDocCopy = $("#inputFileDocCopy")[0].files;
    var fileDocCopyFront = $("#inputFileDocCopyFront")[0].files;
    var fileDocCopyReverse = $("#inputFileDocCopyReverse")[0].files;
    if (fileDocCopy.length != 0 || (fileDocCopyFront.length != 0 && fileDocCopyReverse.length != 0)) {
      isValidFileLoad = true;
    }
    return isValidFileLoad;
  }

  /**
   * Description: Método que realiza la validación para el cambio del número 
   * Autor: Steven Sterling 
   * @param N/A
   * @return N/A
   */
  validChangeNumber() {
    // Respuesta que viene desde un WS
    return true;
  }

  /**
   * Description: Método que realiza el cambio de numero
   * Autor: Steven Sterling 
   * @ModifyBy Ciro - se agrega validaciones para mostrar mensaje de "debe aceptar los terminos y condiciones..."
   * @param N/A
   * @return N/A
   */
  changeNumber() {
    if (this.changeNumberForm.get('inputLines').value && 
      (!this.changeNumberForm.get('checkAuto').value 
      || !this.changeNumberForm.get('checkTerms').value ) && this.validateAttachedFiles()) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_AUT_TERMS');
      this.isShowModal = true;
      return;
    }
    else if (!this.changeNumberForm.get('inputLines').value
      || 
      this.changeNumberForm.get('checkAuto').value == false
      || this.changeNumberForm.get('checkTerms').value == false || !this.validateAttachedFiles()) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      return;
    }

    var fileList = [];
    if (this.fileLoadPortFormData != null) {
      fileList.push({ "name": $('#inputFilePortForm').prop('files')[0].name, "attached": this.fileLoadPortFormData.split(',')[1] });
    }
    if (this.fileLoadDocCopyData != null) {
      fileList.push({ "name": $('#inputFileDocCopy').prop('files')[0].name, "attached": this.fileLoadDocCopyData.split(',')[1] });
    }
    if (this.fileLoadDocCopyFrontData != null) {
      fileList.push({ "name": $('#inputFileDocCopyFront').prop('files')[0].name, "attached": this.fileLoadDocCopyFrontData.split(',')[1] });
    }
    if (this.fileLoadDocCopyReverseData != null) {
      fileList.push({ "name": $('#inputFileDocCopyReverse').prop('files')[0].name, "attached": this.fileLoadDocCopyReverseData.split(',')[1] });
    }

    const userData = JSON.parse(localStorage.getItem("userData"));
    let jsonData = {
      "identification": userData.documentId,
      "msisdn": this.changeNumberForm.get('inputLines').value,
      "customerAccountId": userData.customerAccountId,
      "authorize": constants.YES,
      "acceptTerms": constants.YES,
      "email": userData.email,
      "attached": fileList
    };

    //procesar envio request
    this.isBtnDisabled = true;
    this.changeNumberService.sendChangeNumberRequest(jsonData).subscribe((valData => {
      this.isBtnDisabled = false;

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('CHANGE_NUMBER_LABEL_ERROR_REQUEST');
        this.isShowModal = true;
        return false;
      }

      //habilitar botones
      this.isBtnDisabled = false;
      this.isModalReload = true;
      let ticketNumber = valData["obj"].ticket;
      this.modalTitle = this.LANG.getLangText('CHANGE_NUMBER_BUTTON_MODAL_OK_TITLE');
      this.modalContent = this.LANG.getLangText('CHANGE_NUMBER_BUTTON_MODAL_OK_SUBTITLE') +
        '<div class="fs-30">' + ticketNumber + "</div>" +
        this.LANG.getLangText('CHANGE_NUMBER_BUTTON_MODAL_OK_SUBTITLE_2');
      this.isChangeNumberBtn = true;
      this.isShowModal = true;

    }),
      (err) => {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR') + err.code;
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        this.isBtnDisabled = false;
      });
  }
  /**
   * Description: Método que esconde la ventana modal
   * Autor: Steven Sterling 
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    this.isChangeNumberBtn = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    }
  }

  /**
 * Description: Método que carga el archivo seleccionado
 * Autor: Diego Diaz
 * @param inputValue campo tipo file
 * @param id identificador
 * @return N/A
 */
  getBase64(inputValue, id) {
    var file: File = inputValue.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    var _self = this;
    reader.onload = function () {
      if (id == 'inputFilePortForm') {
        _self.fileLoadPortFormData = reader.result;
      }
      if (id == 'inputFileDocCopy') {
        _self.fileLoadDocCopyData = reader.result;
        $("#inputFileDocCopyFrontFace").val("");
        $("#inputFileDocCopyFront").val("");
        $("#inputFileDocCopyReverseFace").val("");
        $("#inputFileDocCopyReverse").val("");
        _self.fileLoadDocCopyFrontData = null;
        _self.fileLoadDocCopyReverseData = null;
      }
      if (id == 'inputFileDocCopyFront') {
        _self.fileLoadDocCopyFrontData = reader.result;
        $("#inputFileDocCopyFace").val("");
        $("#inputFileDocCopy").val("");
        _self.fileLoadDocCopyData = null;
      }
      if (id == 'inputFileDocCopyReverse') {
        _self.fileLoadDocCopyReverseData = reader.result;
        $("#inputFileDocCopyFace").val("");
        $("#inputFileDocCopy").val("");
        _self.fileLoadDocCopyData = null;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  /**
   * Description: Método que obtiene el imei y marca de una linea
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  handleImei() {

    this.phoneBrand = "";
    this.imei = "";
    this.phoneImei = "";
    this.selectedLine = false;
    //obtenemos la linea seleccionada con:
    this.isBtnDisabled = true;
    this.isLoadingLines = true;
    this.changeNumberService.getInfoLines(this.changeNumberForm.get('inputLines').value).subscribe((data => {
      //habilitar botones
      this.isLoadingLines = false;
      this.isBtnDisabled = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        return;
      }
      this.phoneBrand = data['obj'].brand;
      this.imei = data['obj'].imei;
      this.phoneImei = data['obj'].model;
      this.selectedLine = true;

    }),
      (err) => {
        this.isBtnDisabled = false;
        this.isLoadingLines = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

}
